// extracted by mini-css-extract-plugin
module.exports = {"section":"_31b860be","content":"_d187dd9e","isPreview":"_39a86c67","gridItem":"_2f8c2a9a","footer":"_d09ad832","shimmerLoadingBackground":"_f181d31a"};